// extracted by mini-css-extract-plugin
export default {"menu":"q6kg1N","bottomRight":"mBRK7L","bottomLeft":"o0B3nG"};